import { useState, useEffect } from 'react';

/**
 * useHighlight — reads ?highlight=<value> from URL, returns it, then clears it after 2.5s.
 * List pages use this to scroll-to and briefly style a specific record.
 *
 * Returns: highlightId (string|null)
 *
 * Usage in list pages:
 *   const highlightId = useHighlight();
 *   const isHighlighted = highlightId && (record.id === highlightId || record.order_no === highlightId);
 *   // Apply to row: style={{ border: isHighlighted ? '1px solid hsl(75,100%,50%)' : '...' }}
 */
export function useHighlight() {
  const [highlightId, setHighlightId] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const val = params.get('highlight');
    if (!val) return;
    setHighlightId(val);
    // Clean the URL without navigation
    const url = new URL(window.location.href);
    url.searchParams.delete('highlight');
    window.history.replaceState({}, '', url.toString());
    // Auto-clear highlight after animation completes
    const timer = setTimeout(() => setHighlightId(null), 2500);
    return () => clearTimeout(timer);
  }, []);

  return highlightId;
}
